//import React from 'react';
import Categories from '../components/categories';
import Products from '../components/products';
import NotFound from '../components/notfound';
//let config = require('./data.json');

const routes = [	
	{
		path: `${process.env.REACT_APP_PUBLIC_URL}/index.html`,
		component: Categories,
		isPrivate: true,
	},
	{
		path: `${process.env.REACT_APP_PUBLIC_URL}`,
		component: Categories,
		isPrivate: true,
	},
	{
		path: `${process.env.REACT_APP_PUBLIC_URL}/commercial-systems`,
		component: Products,
		isPrivate: true,
	},
	{
		path: `${process.env.REACT_APP_PUBLIC_URL}/hp-workstations`,
		component: Products,
		isPrivate: true,
	},
	{
		path: `${process.env.REACT_APP_PUBLIC_URL}/displays-accessories`,
		component: Products,
		isPrivate: true,
	},
	{
		path: `${process.env.REACT_APP_PUBLIC_URL}/retail-solutions`,
		component: Products,
		isPrivate: true,
	},
	{
		path: `${process.env.REACT_APP_PUBLIC_URL}/industry-solutions`,
		component: Products,
		isPrivate: true,
	},
	{
		path: `${process.env.REACT_APP_PUBLIC_URL}/*`,
		component: NotFound,
		isPrivate: true,
	},
];

export default routes;
